/* eslint-disable eqeqeq */
import { $t, getLocale } from '@/locales'
import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from './store'
import { getTokenInfo } from './tokenLogin'
import { isFeiShu, isWeWork, clientId } from '@esign/esign-client-jssdk'

// 默认请求头的语言
const headerLocal = getLocale()

const FNtransformRequest = req => {
  req.url = req.url.includes('?') ? `${req.url}&t=${new Date().getTime()}` : `${req.url}?t=${new Date().getTime()}`

  // 设置请求头语言
  try {
    const lang = Vue.prototype.$rootStore.getters['locale/lang']
    if (lang && lang !== headerLocal) {
      req.headers['X-Tsign-Open-Language'] = lang
    }
  } catch (error) {}

  return req
}

// axios 配置
axios.defaults.headers['x-requested-with'] = 'XMLHttpRequest'
axios.defaults.headers['X-Tsign-Open-Language'] = headerLocal
axios.defaults.withCredentials = true

// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    if (!store.state.isOrg) {
      config.headers['Account-Center-Auth'] = 'sys_accountId'
      if (
        ['/orders/getConsumed', '/{gid}/products', '/authed/productList', '/viewContractBillFile'].find(
          item => config.url.indexOf(item) > 0
        )
      ) {
        config.url = config.url.replace('{gid}', 'person')
      } else {
        config.url = config.url.replace('{gid}', 'sys_guid')
      }
      config.url = config.url.replace('{oid}', 'sys_accountId')
    } else {
      config.headers['Account-Center-Auth'] = 'sys_org_id'
      if (
        ['/orders/getConsumed', '/{gid}/products', '/authed/productList', '/viewContractBillFile'].find(
          item => config.url.indexOf(item) > 0
        )
      ) {
        config.url = config.url.replace('{gid}', 'organize')
      } else {
        config.url = config.url.replace('{gid}', 'sys_org_guid')
      }
      config.url = config.url.replace('{oid}', 'sys_org_id')
    }
    if (process.env.groupId) {
      config.headers['X-Tsign-Service-Group'] = `${process.env.groupId}`
    }

    // 飞书和企微环境新增请求头
    if (isFeiShu || isWeWork) {
      config.headers['X-Tsign-Client-Id'] = clientId
    }
    const tokenStore = getTokenInfo()
    if (tokenStore) {
      config.headers['X-Tsign-Open-App-Id'] = tokenStore.AppId
      config.headers['X-Tsign-Open-Authorizer-Token'] = tokenStore.AuthorizerToken
      config.headers['X-Tsign-Open-Authorization-Version'] = tokenStore.AuthorizationVersion
    }

    FNtransformRequest(config)

    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if (response.data.redirectUrl) {
      window.location.href = response.data.redirectUrl
    } else {
      if (response.data.code === 401) {
        // 登录过期，如果存在token需要移除
        localStorage.removeItem('token')
        window.location.href = response.data.data.loginUrl
      }
    }

    return response
  },
  error => {
    if (error.response.status === 302) {
      window.location.href = error.response.data.redirectUrl
    }

    return Promise.reject(error)
  }
)

export default function fetch(conf, params = {}, useMessage = true) {
  const parameters = JSON.parse(JSON.stringify(params)) || {}
  const fetchMethod = conf.method.toLocaleUpperCase()
  const { headers } = conf
  if (fetchMethod === 'POST') {
    return new Promise((resolve, reject) => {
      axios
        .post(conf.url, parameters, { headers })
        .then(
          response => {
            if (
              response.data.success ||
              response.data.code == 0 ||
              response.data.code === 'OK' ||
              response.data.code === 10000000 ||
              response.data.code === 50002013 ||
              response.data.code == 20502100 ||
              response.data.code === 20502002
            ) {
              resolve(response.data)
            } else {
              if (useMessage) {
                Vue.prototype.$message({
                  message: response.data.message,
                  type: 'error',
                })
              }
              reject(response.data)
            }
          },
          err => {
            reject(err)
          }
        )
        .catch(error => {
          reject(error)
        })
    })
  } else if (fetchMethod === 'GET') {
    return new Promise((resolve, reject) => {
      const par = JSON.stringify(parameters) === '{}' ? '' : `?${qs.stringify(parameters)}`
      axios
        .get(conf.url + par, { headers })
        .then(
          response => {
            if (
              response.data.code == 0 ||
              response.data.code === 'OK' ||
              response.data.code === '200' ||
              response.data.success ||
              response.data.code === 10000000 ||
              response.data.code === 20502002
            ) {
              resolve(response.data)
            } else {
              console.log(useMessage)
              if (useMessage) {
                Vue.prototype.$message({
                  message: response.data.message,
                  type: 'error',
                })
              }
              reject(response.data)
            }
          },
          err => {
            reject(err)
          }
        )
        .catch(error => {
          reject(error)
        })
    })
  } else if (fetchMethod === 'DELETE') {
    return new Promise((resolve, reject) => {
      const par = JSON.stringify(parameters) === '{}' ? '' : `?${qs.stringify(parameters)}`
      axios
        .delete(conf.url + par)
        .then(
          response => {
            if (response.data.code === 'OK' || response.data.code == 0 || response.data.code === '200' || response.data.code === 10000000) {
              resolve(response.data)
            } else {
              Vue.prototype.$message({
                message: response.data.message,
                type: 'error',
              })
              reject(response.data)
            }
          },
          err => {
            reject(err)
          }
        )
        .catch(error => {
          reject(error)
        })
    })
  } else if (fetchMethod === 'PATCH') {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${conf.url}?${qs.stringify(parameters)}`)
        .then(
          response => {
            if (response.data.code === 'OK' || response.data.code == 0 || response.data.code === '200') {
              resolve(response.data)
            } else {
              Vue.prototype.$message({
                message: response.data.message,
                type: 'error',
              })
              reject(response.data)
            }
          },
          err => {
            reject(err)
          }
        )
        .catch(error => {
          reject(error)
        })
    })
  } else if (fetchMethod === 'PUT') {
    return new Promise((resolve, reject) => {
      axios
        .put(conf.url, parameters)
        .then(
          response => {
            if (response.data.code === 'OK' || response.data.code == 0 || response.data.code === '200') {
              resolve(response.data)
            } else {
              Vue.prototype.$message({
                message: response.data.message,
                type: 'error',
              })
              reject(response.data)
            }
          },
          err => {
            reject(err)
          }
        )
        .catch(error => {
          reject(error)
        })
    })
  }
  throw new Error($t('暂不支持这个method：{slot1}', { slot1: conf.method }))
}
